import { DatePicker } from "antd";

// App-wide display format + placeholder for day (date-only) pickers. Forced
// here so every date-only picker in the app shows the same "DD-MM-YYYY" format
// and hint, without touching individual screens. This is display-only: forms
// still submit the underlying dayjs value, so changing the shown format is safe.
const DAY_FORMAT = "DD-MM-YYYY";

const BaseDatePicker = (props) => {
  const { format: incomingFormat, picker, placeholder, ...rest } = props;

  const isDayPicker = !picker || picker === "date";

  // Date-only pickers are normalised to DD-MM-YYYY for both display and
  // placeholder, overriding whatever a screen passes. Other pickers (month,
  // year, ...) keep their own format and placeholder.
  const format = isDayPicker ? DAY_FORMAT : incomingFormat;

  const formatHint = typeof format === "string" ? format : undefined;
  const resolvedPlaceholder = isDayPicker
    ? DAY_FORMAT
    : (placeholder ?? formatHint);

  return (
    <DatePicker
      style={ {
        width: '100%',
        height: '48px',
      } }
      { ...rest }
      picker={ picker }
      format={ format }
      placeholder={ resolvedPlaceholder }
    />
  )
}

export default BaseDatePicker
